module.exports = __webpack_public_path__ + "b6f65a9402ca4440e7290ee3c196969d.pdf";